module.exports = __webpack_public_path__ + "src/images/products/sneakerhead/64_Grey Denim Rivingtons Jean.png";